exports = module.exports = require('./lib/node-environment');